<template>
  <div class="main">
    <el-card class="box-card" align="middle">
      <div class="title-content">
        <div class="title-block">
          <span class="login-title" style="margin-top: 8px;">青海省中小企业</span>
          <span class="login-title" style="margin-top: 8px;">诉求意见及保障支付受理平台</span>
        </div>
      </div>
      <el-form
        :model="loginData"
        :rules="rules"
        ref="loginForm"
        class="loginForm">
        <el-form-item prop="account">
          <el-input autofocus="autofocus" placeholder="请输入账号" type="account" v-model="loginData.account" @focus="accountFocus" @blur="accountBlur">
            <i slot="prefix" :style="{color:accountColor}" class="el-input__icon el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" style="margin-top: 30px">
          <el-input placeholder="请输入密码" type="password" v-model="loginData.password" @focus="pswFocus" @blur="pswBlur">
            <i slot="prefix" :style="{color:passwordColor}" class="el-input__icon el-icon-key"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click.native.prevent="login" @keyup.enter.native="login" @click="login()" :loading="loginLoading">登 录</el-button>
      <div class="bottom-span">
        <span class="copyright">copyright@版权所有</span>
      </div>
    </el-card>
  </div>
</template>
<script>
  import md5 from 'js-md5'
  import Common from '@/components/common/Common'
  import { doLogin, currentUser } from '@/api/restapi.js'
  export default {
    created () {
      var _self = this
      document.onkeydown = function (e) {
        if (window.event === undefined) {
          var key = e.keyCode
        } else {
          key = window.event.keyCode
        }
        if (key === 13) {
          _self.login()
        }
      }
    },
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        }
      }
      var validateAccount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'))
        }
      }
      return {
        accountColor: '#C0C4CC',
        passwordColor: '#C0C4CC',
        loginData: {
          account: '',
          password: ''
        },
        loginLoading: false,
        rules: {
          password: [{ validator: validatePass, trigger: 'blur' }],
          account: [{ validator: validateAccount, trigger: 'blur' }]
        }
      }
    },
    mounted () {
    },
    methods: {
      accountFocus () {
        this.accountColor = '#409EFF'
      },
      accountBlur () {
        this.accountColor = '#C0C4CC'
      },
      pswFocus () {
        this.passwordColor = '#409EFF'
      },
      pswBlur () {
        this.passwordColor = '#C0C4CC'
      },
      login () {
        if (this.loginLoading) {
          return
        }
        let isValid = true
        this.$refs['loginForm'].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          return
        }
        this.loginLoading = true
        doLogin(this.loginData.account, md5(this.loginData.password)).then(res => {
          if (res.data.code === 0) {
            currentUser().then(user => {
              if (user.data.code === 0) {
                this.$router.push({path: '/statics'})
              }
            })
          } else {
            this.loginLoading = false
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          console.log(err)
          this.loginLoading = false
          this.$message({
            showClose: true,
            message: '登录请求异常',
            type: 'error'
          })
        })
      }
    }
  }
</script>
<style scoped>
  .main{
    height: 100%;
    background: #0320ac url("../assets/login_bg.jpg") no-repeat top center/100%;
  }
  .box-card{
    background: #ffffff;
    width: 400px;
    margin-right: 50px;
    margin-top: 30px;
    height: 500px;
    float: right;
    padding: 50px;
    position: relative;
  }
  .title-content {
    height: 85px;
  }
  .title-img {
    width: 55px;
    height: 55px;
    vertical-align: middle;
  }
  .title-block {
    text-align: center;
    height: 100%;
    display: inline-block;
    margin-left: 20px;
    vertical-align: middle;
  }
  .login-title{
    font-size: 20px;
    font-weight: bold;
    color: #07438A;
    display: block;
  }
  .loginForm{
    margin-top: 25px;
  }
  .el-input>>>.el-input__inner:focus{
    color: #409EFF !important;
    font-size: 15px;
  }
  .el-input__inner:focus {
    color: #409EFF;
    font-size: 15px;
  }
  .el-button{
    margin-top: 30px;
    width: 100%;
    font-weight: 800;
    font-size: 18px;
  }
  .bottom-span{
    bottom: 50px;
    left: 0;
    width: 100%;
    text-align: center;
    position: absolute;
  }
  .copyright{
    color: #CCCCCC;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue